import MaterialsService from '@/services/codebooks/MaterialsService'

export default {
  namespaced: true,
  state: {
    materialsList: []
  },
  getters: {
    materialsList: state => state.materialsList
  },
  actions: {
    refreshMaterials ({ commit }) {
      return MaterialsService.getAllMaterials()
        .then(list => {
          commit('SET_MATERIALS', list)
        })
    },
    addNewMaterial ({ commit }, material) {
      return MaterialsService.saveMaterial(material).then(result => {
        material.id = result.data
        commit('ADD_MATERIAL', material)
        return material
      })
    },
    editMaterial ({ commit }, material) {
      return MaterialsService.saveMaterial(material).then(result => {
        commit('EDIT_MATERIAL', material)
        return material
      })
    },
    deleteMaterial ({ commit }, material) {
      return MaterialsService.removeMaterial(material).then(result => {
        commit('DELETE_MATERIAL', material)
      })
    }
  },
  mutations: {
    SET_MATERIALS (state, list) {
      state.materialsList = list
    },
    EDIT_MATERIAL (state, material) {
      const current = state.materialsList[material.index]
      current.name = material.name
    },
    ADD_MATERIAL (state, material) {
      const newMaterial = {
        id: material.id,
        name: material.name
      }
      state.materialsList.push(newMaterial)
    },
    DELETE_MATERIAL (state, material) {
      state.materialsList.splice(material.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/materials.js